import { ConfigHeader } from "../../types/config";
import {
  facebookIcon,
  instagramIcon,
  pintrestIconDark,
  // telegramIconLight,
  tiktokIcon,
  youtubeIcon,
} from "../icons/socialIcon";

export const configHeader: ConfigHeader = {
  megaMenu: {
    newsletter: {
      text: "F ZINE is the authority on youth culture and fashion — a media brand like no other in Singapore, casting a diverse and forward-looking lens on what matters to youths today.",
      buttonText: "SIGN UP",
      url: "/newsletter-signup",
    },
    closeButton: {
      icon: (
        <div style={{ fill: "white", width: "40px", height: "40px" }}>
          <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.6 27.2c-.24 0-.48-.09-.67-.26l-9.58-8.72A3.03 3.03 0 0 1 9.37 16c0-.84.36-1.65.98-2.22l9.58-8.72a.997.997 0 1 1 1.34 1.48l-9.58 8.72a1 1 0 0 0-.33.74 1 1 0 0 0 .33.74l9.58 8.72c.41.37.44 1 .07 1.41-.2.22-.47.33-.74.33Z" />
          </svg>
        </div>
      ),
      type: "icon",
      placement: "right",
    },
    divider: {
      footer: true,
    },
  },
  socialMedia: {
    target: "_blank",
    icons: [
      {
        icon: tiktokIcon,
        name: "Tiktok",
        href: "https://www.tiktok.com/@f__zine",
      },
      {
        icon: instagramIcon,
        name: "instagram",
        href: "https://www.instagram.com/f__zine/",
      },
      {
        icon: facebookIcon,
        name: "Facebook",
        href: "https://facebook.com/fzineofficial/",
      },
      // {
      //   icon: telegramIconLight,
      //   name: "telegram",
      //   href: "https://t.me/s/femalesingapore",
      // },
      {
        icon: youtubeIcon,
        name: "youtube",
        href: "http://youtube.com/@f__zine",
      },
      {
        icon: pintrestIconDark,
        name: "pintrest",
        href: "https://pinterest.com/f__zine/",
      },
    ],
  },
};

export const hamburgermenuSvgSource = (
  <svg
    width="25"
    height="18"
    viewBox="0 0 25 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.170898" width="24" height="2" fill="black" />
    <rect x="0.170898" y="7" width="24" height="4" fill="black" />
    <rect x="0.170898" y="16" width="24" height="2" fill="black" />
  </svg>
);
